import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { ILensDetailInfo, ILensInfo } from '../models/ILensInfo';
import { GetLensesRequest } from '../ServerApi/requests/GetLensesRequest';
import { GetFieldValuesRequest } from '../ServerApi/requests/GetFieldValuesRequest';
import { FieldValuesQuery } from './FieldValuesQuery';
import { IActionResource, IDetailResource, IFieldValuesResource, IListResource } from './Resource';
import { ResourceQuery } from './ResourceQuery';
import { LensMapper } from '../mappers/LensMapper';
import { ILensActions } from '../ServerApi/types/ILensAction';
import { GetLensActionsRequest } from '../ServerApi/requests/GetLensActionsRequest';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { WebClientDetailFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientDetailFetcher';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { DeleteLensesRequest } from '../ServerApi/requests/DeleteLensesRequest';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { SetLensesOwnerRequest } from '../ServerApi/requests/SetLensesOwnerRequest';
import { MoveLensesToProjectRequest } from '../ServerApi/requests/MoveLensesToProjectRequest';

export class LensesResource implements IListResource<ILensInfo>, IFieldValuesResource, IDetailResource<ILensDetailInfo>, IActionResource<ILensActions> {

  private listFetcher = new WebClientListResourceFetcher(GetLensesRequest, ServerApiMapper.lenses);
  private detailFetcher = new WebClientDetailFetcher('getLens', LensMapper.mapDetail);
  private fieldValuesFetcher = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<ILensInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string): Promise<ILensDetailInfo> {
    return this.detailFetcher.fetchById(id);
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'lens');
  }

  // Actions
  public actions(id: string): Promise<ILensActions> {
    return WebHttpClient.sendRequest(new GetLensActionsRequest(id));
  }

  public deleteLenses(ids: string[]): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteLensesRequest(idsBlock)),
      ResultHelper.combineResults
    );
  }

  public setOwner(ids: string[], ownerId: string): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetLensesOwnerRequest(idsBlock, ownerId)),
      ResultHelper.combineResults);
  }

  public moveToProject(targetProjectId: string, lensIds: string[]): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(lensIds, (idsBlock) => new MoveLensesToProjectRequest({
        ids: idsBlock,
        projectId: targetProjectId
      })),
      ResultHelper.combineResults);
  }
}

export const Lenses = new LensesResource();
